<template>
  <i class="fa fa-circle" :class="instance.status ? ' text-success' : ' text-danger'" :title="instance.status ? 'Ativo' : 'Inativo'"></i>
</template>

<script>
  export default {
    name: 'StatusComponent',

    props: {
      instance: {
        type: Object,
        default () {
          return {
            media: []
          }
        }
      },
      http: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped>
  i:hover{
    color: inherit !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/StatusComponent.vue